import styled from 'styled-components';
import { Container } from 'styles';

export const ImpactContainer = styled(Container).attrs({
  alignItems: 'center',
  flex: true,
  justifyContent: 'space-between',
})`
  margin: 32px 0;

  > div {
    max-width: 50%;
  }
`;

export const ApproachContainer = styled(Container).attrs({
  direction: 'column',
  flex: true,
  margin: '32px 0',
  padding: '48px 30px',
})`
  background-color: ${props => props.theme.colors.background.secondary};

  && li {
    border: none;
    ${props => props.theme.media.small`
      align-items: flex-start;
      margin

      h3 {
        padding-top: 16px;
      }

      p {
        padding-top: 8px;
      }
    `}
  }
`;
